import { USER_PROP } from 'pages/User/constants'
import { SettingsActionType } from './constants'

export const initialProfileState = {
    inviter: {
        [USER_PROP.FNAME]: '',
        [USER_PROP.LNAME]: '',
        send_date: '',
        type: '',
    },
    user: {
        [USER_PROP.ABOUT]: '',
        [USER_PROP.COUNTRY]: '',
        [USER_PROP.EMAIL]: '',
        [USER_PROP.FNAME]: '',
        [USER_PROP.LNAME]: '',
        [USER_PROP.ROLE]: '',
        [USER_PROP.REQUIRE_2FA]: false,
    },
}
export const initialPwdChgContent = {
    oldPassword: '',
    newPassword: '',
    verifyPassword: '',
}

export const getDefaultState = () => ({
    selectedTab: 'PROFILE',
    profile: initialProfileState,
    isChgPwdDialogOpen: false,
    isConfirmationDialogOpen: false,
    pwdChangeContent: initialPwdChgContent,
})

export default (state = getDefaultState(), action) => {
    switch (action.type) {
        case SettingsActionType.SET_TAB:
            return setTab(state, action)
        case SettingsActionType.SET_PROFILE:
            return setProfile(state, action)
        case SettingsActionType.SET_OPEN_PWD_DIALOG:
            return setPwdVisibility(state, action)
        case SettingsActionType.SET_OPEN_DEACT_DIALOG:
            return setDeactivateVisibility(state, action)
        case SettingsActionType.SET_PWD_DIALOG_CONTENT:
            return setPwdDialogContent(state, action)
        default:
            return state
    }
}
function setPwdDialogContent(state, { content }) {
    return {
        ...state,
        pwdChangeContent: content,
    }
}

function setPwdVisibility(state, { isOpen }) {
    return {
        ...state,
        isChgPwdDialogOpen: isOpen,
        pwdChangeContent: isOpen
            ? state.pwdChangeContent
            : initialPwdChgContent,
    }
}

function setDeactivateVisibility(state, { isOpen }) {
    return {
        ...state,
        isConfirmationDialogOpen: isOpen,
    }
}

function setTab(state, { selectedTab }) {
    return { ...state, selectedTab }
}

function setProfile(state, { data }) {
    return { ...state, profile: data }
}
